export const deriveTwoFactorType = (eligible, shouldForce) => {
  if (!eligible) return 'support';
  if (shouldForce) return 'admin';
  return 'choice';
};
export const deriveTwoFactorErrorType = errorText => {
  if (errorText.includes('EXPIRED_TWO_FACTOR_TOKEN')) {
    return 'TOKEN_EXPIRED';
  }
  if (errorText.includes('EMAIL_NOT_SENT_NEEDS_SUPPORT')) {
    return 'NEEDS_SUPPORT';
  }
  return 'GENERAL_ERROR';
};